module.exports = __webpack_public_path__ + "img/next-round-audi.c5d7b021.png";